import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/enviroments';
import { Clientes } from '../interface/data.interface';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  constructor(private http: HttpClient) { }

  public getAllCompanies(
    start: any,
    end: any,
    page: number,
    search: string,
    size: number,
    sii: boolean | null,
    isPyme,
    sortOrder: string
  ) {
    const siiQuery = sii != null ? `&sii=${sii}` : '';
    // const pymeQuery = isPyme != null ? `&isPyme=${isPyme}` : '';
    const endpoint = `${environment.apiUrl}/DashboardFactoring/clientes?start=${start}&end=${end}&page=${page}&search=${search}&size=${size}${siiQuery}&isPyme=${isPyme}&sortOrder=${sortOrder}`;
    return this.http.get<PageResult<Clientes>>(endpoint);
  }

  public getCompaniesSinAsingnar(
    start: any,
    end: any,
    page: number,
    search: string,
    size: number,
    sii: boolean | null,
    isPyme,
    sortOrder: string
  ) {
    const siiQuery = sii != null ? `&sii=${sii}` : '';
    // const pymeQuery = isPyme != null ? `&isPyme=${isPyme}` : '';
    const endpoint = `${environment.apiUrl}/DashboardFactoring/clientesSinAsignar?start=${start}&end=${end}&page=${page}&search=${search}&size=${size}${siiQuery}&isPyme=${isPyme}&sortOrder=${sortOrder}`;
    return this.http.get<PageResult<Clientes>>(endpoint);
  }

}
